/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SecureFileVersionResponse
 */
export interface SecureFileVersionResponse {
    /**
     * 
     * @type {string}
     * @memberof SecureFileVersionResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SecureFileVersionResponse
     */
    fileId?: string;
    /**
     * 
     * @type {number}
     * @memberof SecureFileVersionResponse
     */
    versionNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof SecureFileVersionResponse
     */
    sizeBytes?: number;
    /**
     * 
     * @type {string}
     * @memberof SecureFileVersionResponse
     */
    contentType?: string;
    /**
     * 
     * @type {string}
     * @memberof SecureFileVersionResponse
     */
    checksumSha256?: string;
    /**
     * 
     * @type {string}
     * @memberof SecureFileVersionResponse
     */
    uploadedBy?: string;
    /**
     * 
     * @type {Date}
     * @memberof SecureFileVersionResponse
     */
    uploadedAt?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof SecureFileVersionResponse
     */
    externalStorage?: boolean;
}

/**
 * Check if a given object implements the SecureFileVersionResponse interface.
 */
export function instanceOfSecureFileVersionResponse(value: object): value is SecureFileVersionResponse {
    return true;
}

export function SecureFileVersionResponseFromJSON(json: any): SecureFileVersionResponse {
    return SecureFileVersionResponseFromJSONTyped(json, false);
}

export function SecureFileVersionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecureFileVersionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'fileId': json['fileId'] == null ? undefined : json['fileId'],
        'versionNumber': json['versionNumber'] == null ? undefined : json['versionNumber'],
        'sizeBytes': json['sizeBytes'] == null ? undefined : json['sizeBytes'],
        'contentType': json['contentType'] == null ? undefined : json['contentType'],
        'checksumSha256': json['checksumSha256'] == null ? undefined : json['checksumSha256'],
        'uploadedBy': json['uploadedBy'] == null ? undefined : json['uploadedBy'],
        'uploadedAt': json['uploadedAt'] == null ? undefined : (new Date(json['uploadedAt'])),
        'externalStorage': json['externalStorage'] == null ? undefined : json['externalStorage'],
    };
}

export function SecureFileVersionResponseToJSON(json: any): SecureFileVersionResponse {
    return SecureFileVersionResponseToJSONTyped(json, false);
}

export function SecureFileVersionResponseToJSONTyped(value?: SecureFileVersionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'fileId': value['fileId'],
        'versionNumber': value['versionNumber'],
        'sizeBytes': value['sizeBytes'],
        'contentType': value['contentType'],
        'checksumSha256': value['checksumSha256'],
        'uploadedBy': value['uploadedBy'],
        'uploadedAt': value['uploadedAt'] == null ? undefined : ((value['uploadedAt']).toISOString()),
        'externalStorage': value['externalStorage'],
    };
}

